import { Button, Flex, Typography } from 'antd';
import { CheckCircleFilled, ExclamationCircleFilled, InfoCircleFilled, MailOutlined } from '@ant-design/icons';
import { spacing, textColor } from '../../theming';
import ManageLink from './ManageLink';

const ICONS = {
    ok: <CheckCircleFilled style={{ fontSize: 56, color: textColor.success }} />,
    info: <InfoCircleFilled style={{ fontSize: 56, color: textColor.link }} />,
    warn: <ExclamationCircleFilled style={{ fontSize: 56, color: textColor.warning }} />,
    mail: <MailOutlined style={{ fontSize: 56, color: textColor.link }} />,
};

// one state of the unsubscribe page: its icon, copy (unsubscribe:<key>.title / .text) and the actions it offers
export default function StateView({ view, t, headingRef, onUnsubscribe, onSubscribe, onRetry }) {
    const primaries = {
        unsubscribe: (
            <Button type="primary" size="large" onClick={onUnsubscribe}>
                {t('unsubscribe:confirm.button')}
            </Button>
        ),
        retry: (
            <Button type="primary" size="large" onClick={onRetry}>
                {t('unsubscribe:retry.button')}
            </Button>
        ),
        manage: <ManageLink t={t} asButton />,
    };

    return (
        <Flex vertical align="center" gap={spacing[3]}>
            {ICONS[view.icon]}
            <Typography.Title level={3} ref={headingRef} tabIndex={-1} style={{ margin: 0, outline: 'none' }}>
                {t(`unsubscribe:${view.key}.title`)}
            </Typography.Title>
            <Typography.Paragraph style={{ margin: 0, color: textColor.secondary }}>
                {t(`unsubscribe:${view.key}.text`)}
            </Typography.Paragraph>
            {view.primary && primaries[view.primary]}
            {view.subscribeAgain && (
                <Flex vertical align="center" gap={spacing[1]}>
                    <Typography.Text>{t('unsubscribe:changedMind')}</Typography.Text>
                    <Button size="large" onClick={onSubscribe}>
                        {t('unsubscribe:subscribeAgain')}
                    </Button>
                </Flex>
            )}
            {view.manage && <ManageLink t={t} />}
        </Flex>
    );
}
